(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["batch-two-review"]) return;
  try {
    
(() => {
  const root=document.querySelector('[data-batch-two-review]');
  if(!root) return;
  const key='elite-batch-two-review-v1';
  const cards=[...root.querySelectorAll('[data-review-id]')];
  const progress=root.querySelector('[data-review-progress]');
  const copy=root.querySelector('[data-review-copy]');
  const reset=root.querySelector('[data-review-reset]');
  const editorBase='https://admin.shopify.com/store/jchuw1-1u/themes/160924795029/editor?previewPath=';
  let state={};
  try{state=JSON.parse(localStorage.getItem(key)||'{}');}catch(e){state={};}

  root.querySelectorAll('a[href^="/t/33/"]').forEach((link)=>{
    const path=link.getAttribute('href').replace('/t/33','')||'/';
    link.href=editorBase+encodeURIComponent(path);
  });

  const save=()=>localStorage.setItem(key,JSON.stringify(state));
  const render=()=>{
    const counts={approved:0,changes:0,rejected:0,pending:0};
    cards.forEach((card)=>{
      const id=card.dataset.reviewId;
      const item=state[id]||{status:'pending',note:''};
      counts[item.status]=(counts[item.status]||0)+1;
      card.dataset.reviewStatus=item.status;
      const box=card.querySelector('[data-review-check]');
      const select=card.querySelector('[data-review-status]');
      const display=card.querySelector('[data-review-note-display]');
      box.checked=item.status==='approved';
      select.value=item.status;
      display.textContent=item.note||'No feedback added.';
    });
    progress.textContent=counts.approved+' approved • '+counts.changes+' changes • '+counts.rejected+' not approved • '+counts.pending+' pending';
  };

  cards.forEach((card)=>{
    const id=card.dataset.reviewId;
    const feedback=document.createElement('div');
    feedback.className='review-card__feedback';
    feedback.innerHTML='<label>Review decision</label><select data-review-status><option value="pending">Pending</option><option value="approved">Approved</option><option value="changes">Changes requested</option><option value="rejected">Do not approve</option></select><button type="button" class="button button--secondary" data-review-note-button>Add / Edit feedback</button><div class="review-feedback-display" data-review-note-display>No feedback added.</div>';
    card.insertBefore(feedback,card.querySelector('a.button'));

    const box=card.querySelector('[data-review-check]');
    const select=card.querySelector('[data-review-status]');
    const noteButton=card.querySelector('[data-review-note-button]');

    box.addEventListener('change',()=>{
      state[id]=state[id]||{status:'pending',note:''};
      state[id].status=box.checked?'approved':'pending';
      save();render();
    });
    select.addEventListener('change',()=>{
      state[id]=state[id]||{status:'pending',note:''};
      state[id].status=select.value;
      save();render();
    });
    noteButton.addEventListener('click',()=>{
      state[id]=state[id]||{status:'pending',note:''};
      const next=window.prompt('Feedback for this item:',state[id].note||'');
      if(next===null) return;
      state[id].note=next.trim();
      save();render();
    });
  });

  copy.addEventListener('click',async()=>{
    const groups={approved:[],changes:[],rejected:[],pending:[]};
    cards.forEach((card)=>{
      const id=card.dataset.reviewId;
      const item=state[id]||{status:'pending',note:''};
      const title=card.querySelector('strong').textContent.trim();
      groups[item.status].push('- '+id+': '+title+(item.note?'\n  Feedback: '+item.note:''));
    });
    const out=['ELITE Batch 2 review feedback','','APPROVED ('+groups.approved.length+')',...(groups.approved.length?groups.approved:['- None']),'','CHANGES REQUESTED ('+groups.changes.length+')',...(groups.changes.length?groups.changes:['- None']),'','DO NOT APPROVE ('+groups.rejected.length+')',...(groups.rejected.length?groups.rejected:['- None']),'','PENDING ('+groups.pending.length+')',...(groups.pending.length?groups.pending:['- None'])].join('\n');
    try{await navigator.clipboard.writeText(out);copy.textContent='Feedback copied';setTimeout(()=>copy.textContent='Copy review feedback',1800);}catch(e){window.prompt('Copy this review feedback:',out);}
  });
  reset.addEventListener('click',()=>{state={};localStorage.removeItem(key);render();});
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-dock-enquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-enquiry-form]');
    const picker = root.querySelector('[data-photos]');
    const previews = root.querySelector('[data-previews]');
    const status = root.querySelector('[data-status]');
    const button = root.querySelector('[data-submit]');
    const submitLabel = button.textContent;
    const messages = JSON.parse(root.querySelector('[data-enquiry-messages]').textContent);
    const mobile = window.matchMedia('(max-width: 749px)');
    const wrapper = root.closest('.shopify-section') || root;
    const place = () => {
      const slot = document.querySelector(`[data-enquiry-slot="${mobile.matches ? 'mobile' : 'desktop'}"]`);
      if (slot && !slot.contains(root)) slot.append(wrapper);
    };
    place();
    mobile.addEventListener('change', place);
    document.addEventListener('shopify:section:load', place);
    const accepted = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif']);
    let photos = [];
    let busy = false;
    let lastSuccess = 0;
    const notice = (message, error = true) => { status.textContent = message; status.dataset.error = String(error); };
    const clearPhotos = () => { photos.forEach(p => URL.revokeObjectURL(p.url)); photos = []; previews.replaceChildren(); picker.value = ''; };
    const render = () => {
      previews.replaceChildren();
      photos.forEach((photo, index) => {
        const item = document.createElement('li');
        const img = document.createElement('img'); img.src = photo.url; img.alt = photo.file.name;
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = messages.remove;
        remove.addEventListener('click', () => { if (busy) return; URL.revokeObjectURL(photo.url); photos.splice(index, 1); render(); });
        item.append(img, remove); previews.append(item);
      });
    };
    picker.addEventListener('change', () => {
      if (busy) { picker.value = ''; return; }
      const chosen = Array.from(picker.files);
      picker.value = '';
      if (photos.length + chosen.length > 4) { notice(messages.count); return; }
      if (chosen.some(file => !accepted.has(file.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name))) { notice(messages.type); return; }
      if (chosen.some(file => file.size > 12 * 1024 * 1024)) { notice(messages.size); return; }
      chosen.forEach(file => photos.push({ file, url: URL.createObjectURL(file) })); render(); notice('', false);
    });
    const encode = async (photo, index) => {
      const img = new Image(); img.src = photo.url;
      try { await img.decode(); } catch { throw new Error(messages.decode); }
      let scale = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
      const ctx = canvas.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height); ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      let quality = .86;
      let data = canvas.toDataURL('image/jpeg', quality).split(',')[1];
      while (data.length > 1200000 && quality > .36) { quality -= .1; data = canvas.toDataURL('image/jpeg', quality).split(',')[1]; }
      if (!data || data.length > 1200000) throw new Error(messages.size);
      return { filename: `dock-photo-${index + 1}.jpg`, mime: 'image/jpeg', data };
    };
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      if (!photos.length) { notice(messages.missing); picker.focus(); return; }
      if (Date.now() - lastSuccess < 60000) { notice(messages.recent); return; }
      busy = true; button.disabled = true; picker.disabled = true; button.textContent = messages.sending; notice(messages.sending, false);
      try {
        const endpoint = new URL(root.dataset.endpoint);
        if (endpoint.protocol !== 'https:' || endpoint.hostname !== 'hook.us2.make.com') throw new Error(messages.error);
        const data = new FormData(form);
        if (String(data.get('website') || '').trim()) throw new Error(messages.error);
        const payload = { source: 'elite-dock-protection', consent: data.get('consent') === 'on', photos: [] };
        for (const key of ['name', 'email', 'phone', 'location', 'length', 'message', 'website']) payload[key] = String(data.get(key) || '').trim();
        for (let i = 0; i < photos.length; i++) payload.photos.push(await encode(photos[i], i));
        const response = await fetch(endpoint.href, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(60000) });
        const result = await response.json();
        if (!response.ok || result.ok !== true) throw new Error(messages.error);
        lastSuccess = Date.now(); form.reset(); clearPhotos(); notice(messages.success, false); status.focus();
      } catch (error) { notice([messages.size, messages.decode].includes(error.message) ? error.message : messages.error); status.focus(); }
      finally { busy = false; button.disabled = false; picker.disabled = false; button.textContent = submitLabel; }
    });
  };
  document.querySelectorAll('[data-dock-enquiry]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-dock-enquiry]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-pop-165"] && !Shopify.designMode) return;
  try {
    
function initElitePop(root) {
  root.querySelectorAll('.elite-pop').forEach(section => {
    const select = section.querySelector('[data-pop-color]');
    if (!select || select.dataset.ready) return;
    select.dataset.ready = 'true';
    const labels = JSON.parse(section.querySelector('[data-pop-labels]').textContent);
    const update = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      section.querySelector('[name=quantity]').max = option.dataset.stock;
      section.querySelectorAll('[data-pop-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.popChoice === select.value)));
      section.querySelector('[data-pop-price]').textContent = option.dataset.price;
      section.querySelector('[data-pop-stock]').textContent = available ? labels.available : labels.soldOut;
      const button = section.querySelector('[data-pop-submit]');
      button.disabled = !available;
      button.querySelector('[data-pop-submit-text]').textContent = available ? labels.add : labels.soldOut;
      const img = section.querySelector('.elite-pop__selected-image');
      img.removeAttribute('srcset');
      img.src = option.dataset.image;
      img.alt = option.dataset.alt;
    };
    select.addEventListener('change', update);
    section.querySelectorAll('[data-pop-choice]').forEach(choice => choice.addEventListener('click', () => { select.value = choice.dataset.popChoice; update(); }));
    const gallery = section.querySelector('[data-pop-gallery]');
    if (gallery) {
      const previous = section.querySelector('[data-pop-prev]');
      const next = section.querySelector('[data-pop-next]');
      const sync = () => { previous.disabled = gallery.scrollLeft < 2; next.disabled = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 2; };
      const move = direction => { const slide = gallery.querySelector('figure'); if (slide) gallery.scrollBy({left:direction * (slide.offsetWidth + 20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); };
      previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      gallery.addEventListener('scroll',sync,{passive:true}); window.addEventListener('resize',sync); sync();
      section.querySelectorAll('[data-pop-gallery-choice]').forEach(link => link.addEventListener('click', () => { select.value = link.dataset.popGalleryChoice; update(); }));
    }
    update();
  });
}
initElitePop(document);
document.addEventListener('shopify:section:load', event => initElitePop(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
